import moment from 'moment'

const utils = {

    setFileNames(files) {
        localStorage.setItem('files', JSON.stringify(files))
    },

    getFileNames() {
        let items = localStorage.getItem('files')
        if (items === 'undefined' || items === null || items.length === 0) {
            return null
        }
        return JSON.parse(items);
    },

    setExchangeData(data) {
        if (data) {
            localStorage.setItem('exchange_data', JSON.stringify(data))
        }
    },

    getExchangeData() {
        let items = localStorage.getItem('exchange_data')
        if (items === 'undefined' || items === null) return []
        else return JSON.parse(localStorage.getItem('exchange_data'))
    },

    setStatements(data) {
        if (data) {
            localStorage.setItem('statement_items', JSON.stringify(data))
        }
    },
    getStatements() {
        let items = localStorage.getItem('statement_items')
        if (items === 'undefined' || items === null) return null
        else return JSON.parse(localStorage.getItem('statement_items'))
    },

    removeSavedPairedItems() {
        localStorage.setItem('saved_pairing_data', [])
    },

    resetLocalStorage() {
        localStorage.setItem('files', [])
        localStorage.setItem('saved_pairing_data', [])
        localStorage.setItem('bank_rule_based_assigned_items', [])
        localStorage.removeItem('pairing_data')
        localStorage.setItem('unpairing_data', [])
        localStorage.removeItem('bank_assigned_items')
        localStorage.removeItem('bank_statement_items')
        localStorage.removeItem('exchange_data')
    },

    getConfigsKontir(obj) {
        return {
            buyer_supplier_bookkeeping_number_input_1: obj.fields.buyer_supplier_bookkeeping_number_input_1.value,
            buyer_supplier_bookkeeping_number_input_2: obj.fields.buyer_supplier_bookkeeping_number_input_2.value,
            buyer_supplier_bookkeeping_number_input_3: obj.fields.buyer_supplier_bookkeeping_number_input_3.value,
            buyer_supplier_bookkeeping_number_input_4: obj.fields.buyer_supplier_bookkeeping_number_input_4.value,
            buyer_supplier_bookkeeping_number_input_5: obj.fields.buyer_supplier_bookkeeping_number_input_5.value,
            buyer_supplier_bookkeeping_number_input_6: obj.fields.buyer_supplier_bookkeeping_number_input_6.value,
            buyer_supplier_bookkeeping_number_input_7: obj.fields.buyer_supplier_bookkeeping_number_input_7.value,
            buyer_supplier_bookkeeping_number_input_8: obj.fields.buyer_supplier_bookkeeping_number_input_8.value,
            buyer_supplier_bookkeeping_number_input_9: obj.fields.buyer_supplier_bookkeeping_number_input_9.value,
            buyer_supplier_bookkeeping_number_input_10: obj.fields.buyer_supplier_bookkeeping_number_input_10.value,
            unknown_items_code: obj.fields.unknown_items_code.value,
            bank_account_number_code: obj.fields.bank_account_number_code.value,
            start_date: moment(obj.date.start).format('YYYY-MM-DD'),
            end_date: moment(obj.date.end).format('YYYY-MM-DD'),
            bank_exchange: obj.fields.bank_exchange ? obj.fields.bank_exchange.value : 'HUF',
            company_exchange: obj.fields.company_exchange ? obj.fields.company_exchange.value : 'HUF',
        };
    },
    getConfigsRlb(obj) {
        return {
            buyer_supplier_bookkeeping_number_input_1: obj.fields.buyer_supplier_bookkeeping_number_file_1.value,
            buyer_supplier_bookkeeping_number_input_2: obj.fields.buyer_supplier_bookkeeping_number_file_2.value,
            unknown_items_code: obj.fields.unknown_items_code.value,
            bank_account_number_code: obj.fields.bank_account_number_code.value,
            bank_statement_number: obj.fields.bank_statement_number.value,
            start_date: moment(obj.date.start).format('YYYY-MM-DD'),
            end_date: moment(obj.date.end).format('YYYY-MM-DD'),
            bank_exchange: obj.fields.bank_exchange ? obj.fields.bank_exchange.value : 'HUF',
            company_exchange: obj.fields.company_exchange ? obj.fields.company_exchange.value : 'HUF',
            job_number: obj.fields.job_number.value
        };
    },
    arrayHasDuplicates(array) {
        return (new Set(array)).size !== array.length;
    }
};

export default utils


// WEBPACK FOOTER //
// ./src/helpers/bankHelper.js